import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SavePlanificador } from '../../shared/components';
import { useParams } from 'react-router-dom';

export interface CreatePlanificadorProps { }

const CreatePlanificador: React.FC<CreatePlanificadorProps> = () => {
  useCheckPermissions(PermissionsEnum.api_view_planificador);

  const { idFlota } = useParams();

  if (!idFlota) return null;


  return (
    <SavePlanificador titlePage="📅 Crear Planificador" idFlota={idFlota} />
  );
};

export default CreatePlanificador;
